<template>
  <div style="display: inline-block; vertical-align: inherit;padding-left: 25px;">
    <div v-if="loaded" class="group-badge" v-for="user in data">
      <UserBadgeComponent v-if="hasUserById(user.id)" :key="user.id" :user="user"
                          :display-name="!collapse" :border="collapse"></UserBadgeComponent>
    </div>
    <div v-bind:class="{hidden: hasMultiple}" v-if="!loaded" style="margin-left:-2.5rem;">
      <Skeleton :circle="true" :height="33" :width="33" :loading="!loaded"
                style="vertical-align: middle;"></Skeleton>
      <Skeleton :height="20" :width="40" :loading="!loaded" style="vertical-align: middle;"></Skeleton>
    </div>
    <div v-bind:class="{hidden: !hasMultiple}" v-if="!loaded" style="margin-left:-2.5rem;">
      <Skeleton v-for="(n,index) in userCount" :key="index" :circle="true" :height="33" :width="33"
                :loading="!loaded" style="vertical-align: middle;margin-right:-1.8rem;"></Skeleton>
    </div>
  </div>
</template>

<script>
import { Skeleton } from 'vue-loading-skeleton'
import UserBadgeComponent from '../../user/components/BadgeComponent'
import { mapActions, mapGetters } from 'vuex'
import store from '../store'

export default {
  name: 'BadgeGroupComponent',
  components: { UserBadgeComponent, Skeleton },
  props: {
    users: {
      type: Array,
      required: false,
      default: () => ([])
    },
    userIds: {
      type: Array,
      required: false,
      default: () => ([])
    }
  },
  beforeCreate () {
    const STORE_KEY = '$_user'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
  },
  data () {
    return {
      loaded: false,
    }
  },
  computed: {
    ...mapGetters('$_user', ['getUsersByIds', 'hasUserById']),
    collapse: function () {
      return (this.data.length) > 1
    },
    hasMultiple: function () {
      return this.users.length > 1 || this.userIds.length > 1
    },
    userCount: function () {
      return this.users.length || this.userIds.length || 0
    },
    data () {
      return this.getUsersByIds(this.userIds)
    }
  },
  mounted () {
    if (this.users.length === 0 && this.userIds.length > 0) {
      this.fetchUsersByIds(this.userIds)
        .then(() => {
          this.loaded = true
        })
    } else {
      this.$store.commit('$_user/CACHE_USERS', this.users)
      this.loaded = true
    }
  },
  methods: {
    ...mapActions('$_user', ['fetchUsersByIds'])
  }
}
</script>

<style>
.group-badge {
  display: inline-block;
  vertical-align: inherit;
  margin-left: -25px;
}
</style>
